module.exports = __webpack_public_path__ + "static/media/trash-b.091d1d84.svg";